import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const CONSENT_KEY = "bitgenix_cookie_consent";
const OPEN_EVENT = "bitgenix:open-cookie-banner";

function readConsent() {
  try {
    return window.localStorage.getItem(CONSENT_KEY);
  } catch (error) {
    return null;
  }
}

function writeConsent(value) {
  try {
    window.localStorage.setItem(CONSENT_KEY, value);
  } catch (error) {
    // Ignore storage failures and continue gracefully.
  }
}

export function openCookieBanner() {
  window.dispatchEvent(new Event(OPEN_EVENT));
}

export default function CookieConsentBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(!readConsent());

    const handleOpen = () => setIsVisible(true);
    window.addEventListener(OPEN_EVENT, handleOpen);

    return () => {
      window.removeEventListener(OPEN_EVENT, handleOpen);
    };
  }, []);

  const handleAccept = () => {
    writeConsent("accepted");
    if (typeof window.enableBitgenixAnalytics === "function") {
      window.enableBitgenixAnalytics();
    }
    setIsVisible(false);
  };

  const handleDecline = () => {
    writeConsent("declined");
    if (typeof window.disableBitgenixAnalytics === "function") {
      window.disableBitgenixAnalytics();
    }
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-[80] px-4 pb-4 sm:px-6 sm:pb-6" data-testid="cookie-banner">
      <div className="mx-auto max-w-5xl border border-[#21324D]/10 bg-white shadow-[0_18px_60px_-18px_rgba(33,50,77,0.28)]">
        <div className="grid gap-6 px-6 py-6 sm:px-8 sm:py-7 lg:grid-cols-[minmax(0,1fr),auto] lg:items-end">
          <div>
            <p className="font-body text-xs uppercase tracking-[0.16em] text-[#A7A55C] mb-3">
              Cookie Notice
            </p>
            <h3 className="font-heading font-semibold text-2xl text-[#21324D] mb-3">
              Choose how BitGenix uses cookies
            </h3>
            <p className="font-body text-sm text-[#383A46] leading-relaxed max-w-3xl">
              We use essential cookies and local storage to keep the website working. With your permission, we also use analytics cookies to understand site usage and improve the BitGenix experience. See our{" "}
              <Link to="/privacy-policy" className="text-[#A7A55C] hover:text-[#8C8A4A] underline underline-offset-4">
                Privacy Policy
              </Link>{" "}
              for more detail on tools such as Google Analytics and Microsoft Clarity.
            </p>
          </div>
          <div className="flex flex-wrap gap-3 lg:justify-end">
            <button
              type="button"
              onClick={handleDecline}
              className="border border-[#21324D]/15 px-5 py-3 font-body text-sm font-semibold text-[#21324D] transition-colors hover:border-[#A7A55C] hover:text-[#A7A55C]"
            >
              Decline
            </button>
            <button
              type="button"
              onClick={handleAccept}
              className="bg-[#A7A55C] px-5 py-3 font-body text-sm font-semibold text-[#F5F5F2] transition-colors hover:bg-[#8C8A4A]"
            >
              Accept Cookies
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
